import React, { Component } from 'react';
var Dropzone = require('react-dropzone');
var async = require('async');


/* drag and drop for images */

import ProductImage from 'dashboard/products/ProductImage.js';
import update from 'react/lib/update';

import { ControlLabel } from 'react-bootstrap';
import withDragAndDropContext from 'shared/withDragAndDropContext';

class ImageList extends Component {

    constructor(props) {
        super(props);
        this.moveImage = this.moveImage.bind(this);
        //  this.saveImage = this.saveImage.bind(this);
        this.deleteImage = this.deleteImage.bind(this);
        this.reorderImages = this.reorderImages.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onDropImage = this.onDropImage.bind(this);
        this.state = {
            images: this.props.images || [],
            pending: false,
        };


    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.images.length !== this.state.images) {
            this.setState({ 'images': nextProps.images });
        }
    }

    moveImage(dragIndex, hoverIndex) {

    }

    reorderImages() {
        this.setState({ pending: true });
        var self = this;
        var images = _.map(this.state.images, '_id');

        this.props.reorderImages({ 'images': images }, {
            'productID': this.props.currentRecord._id,
        }).then(function (response) {
            self.setState({ pending: false });
        }).catch(function (response) {
            self.setState({ pending: false });
        })

    }

    // saveImage(image) {
    //      var imageData = _.pick(image, ['Caption']);
    //     var methodData = {
    //         "type":'patch',
    //         'endpoint': '/products/' + encodeURIComponent(this.props.currentProduct._id) + '/images/'+ encodeURIComponent(image._id),
    //          'messageData': {'#1#': 'Image'},
    //         messageCode:'recordUpdated',
    //     };
    //     this.props.makeRequest(imageData, methodData).then(function (response) {
    //
    //     })
    //
    // }

    deleteImage(image) {
        var self = this;
        this.setState({ pending: true });
        if (this.props.deleteImage) {
            var promise = this.props.deleteImage(image)
        } else {

            var promise = this.props.makeRequest({}, {
                'endpoint': '/' + this.props.model + '/' + encodeURIComponent(this.props.currentRecord._id) + '/images/' + encodeURIComponent(image._id),
                type: 'delete',
            })
        }
        promise.then(function (response) {
            var itemIndex = _.findIndex(self.state.images, { '_id': image._id });
            var updatedImages = [...self.state.images.slice(0, itemIndex),
            ...self.state.images.slice(itemIndex + 1)];

            self.setState({ pending: false, images: updatedImages })
        }).catch(function (response) {
            self.setState({ pending: false });
        });
    }

    onDropImage(dropResult, monitor) {
        this.setState({ pending: true });
        let index = dropResult.index
        let originalIndex = dropResult.originalIndex
        let images = this.state.images
        let originalImage = images[originalIndex]
        let changeImage = images[index]

        originalImage.Position = index
        changeImage.Position = originalIndex

        images[index] = originalImage
        images[originalIndex] = changeImage

        this.setState({ pending: false, images: images })
    }

    onDrop(acceptedFiles, rejectedFiles) {
        var self = this;
        if (_.size(rejectedFiles) > 0) {
            return self.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorFileUpload'
            });
        }
        this.setState({ pending: true });
        var functionsToCall = [];
        if (this.props.maximumNumberOfImagesToUpload) {
            acceptedFiles = acceptedFiles.slice(0, this.props.maximumNumberOfImagesToUpload)
        }
        _.forEach(acceptedFiles, function (file, key) {
            functionsToCall.push(function (done) {
                //  file.firstImageOnCreate = false;
                var highestPositionImages = _.sortBy(self.state.images, function (o) {
                    return o.Position;
                });
                var nextPosition = !_.isUndefined(_.last(highestPositionImages)) && !_.isUndefined(_.last(highestPositionImages).Position) ? parseInt(_.last(highestPositionImages).Position) + 1 : 1
                self.uploadImage(file, nextPosition, done);
            });
        });
        async.parallel(functionsToCall,
            function (err, uploadResponses) {
                if (err) {

                }
                if (self.props.uploadImagesSuccess) {
                    self.props.uploadImagesSuccess(_.map(uploadResponses, item => {
                        return item.data
                    }))
                }
                self.setState({ pending: false });
            });
    }


    uploadImage(file, nextPosition, done) {
        var self = this;
        var data = new FormData();
        data.append('file', file);
        data.append('Position', nextPosition);
        if (this.props.doNotSaveImageInRecord) {
            data.append('doNotSaveImageInRecord', true);
        }
        var methodData = {
            "type": 'post',
            'endpoint': '/' + this.props.model + '/' + encodeURIComponent(this.props.currentRecord._id) + '/images/upload',
            'messageCode': _.get(this.props, 'uploadImageMessage', 'Image uploaded'),
        };
        this.props.makeRequest(data, methodData).then(function (response) {
            console.log('in image state', response.data);
            self.setState({
                pending: false
                // , images:_.concat([...self.state.images], [response.data])
            })
            done(null, response);
        }).catch(function (err) {
            self.setState({ pending: false });
        })
    }

    render() {
        return (
            <div style={{ position: 'relative' }}>
                {this.state.pending &&
                    <div className="pending-box"></div>
                }
                <div className={(this.state.pending ? 'pending' : '')}>


                    {_.map(_.sortBy(this.state.images, 'Position'), (image, i) => {
                        return <ProductImage
                            key={image._id + '_' + i}
                            ref={image._id}
                            index={i}
                            image={image}
                            moveImage={this.moveImage}
                            onImageSelect={this.props.onImageSelect}
                            selectedImage={this.props.selectedImage}
                            displayCustomContent={this.props.displayCustomContent}
                            deleteImage={this.deleteImage}
                            saveImage={this.props.saveImage ? this.saveImage : false}
                            reorderImages={this.props.reorderImages ? this.reorderImages : _.noop}
                            onDrop={this.onDropImage}
                        />
                    })}


                    <div className="clearfix"></div>
                    {_.get(this.props, 'displayUploadImageBox', true) &&
                        <div className="top20">
                            <div className="text-left text-bold bot10">Upload image</div>
                            <Dropzone
                                style={{
                                    width: 200,
                                    height: 200,
                                    borderWidth: 2,
                                    borderColor: '#666',
                                    borderStyle: 'dashed',
                                    borderRadius: 5, display: 'flex', alignItems: 'center'
                                }}
                                className="cursor-pointer"
                                multiple={true}
                                //  className="flex-box"
                                onDrop={this.onDrop}
                                accept="image/*"
                                maxSize={8388608} // 8mb
                            >
                                <div className="  pleft3 pright3">Try dropping some files here or click to select files to
                                    upload.
                                </div>
                            </Dropzone>

                        </div>
                    }
                </div>
            </div >
        );
    }
}
export default withDragAndDropContext(ImageList)


